import { BasePage } from '@/components/ui/base-page'
import { Routes, Route } from 'react-router-dom'
import { DerivativesPage } from './DerivativesPage'
import { CommoditiesContractsPage } from './CommoditiesContractsPage'
export function InstrumentsPage() {
  return (
    <BasePage
      title="Financial Instruments"
      description="Investment vehicles and tools"
    >
      <Routes>
        <Route path="derivatives" element={<DerivativesPage />} />
        <Route path="commodities" element={<CommoditiesContractsPage />} />
      </Routes>
    </BasePage>
  )
}